import axios, { type AxiosError, type AxiosResponse } from "axios";

export interface CreateRequestOptions {
  baseURL: string;
  timeout?: number;
}

export function createAutoRequest(
  options: CreateRequestOptions,
  interceptorResponse: (response: AxiosResponse) => AxiosResponse,
  interceptorReject: (error: AxiosError) => Promise<never>
) {
  const { baseURL, timeout = 30000, ...otherOptions } = options;

  const autoRequest = axios.create({
    baseURL,
    timeout,
    ...otherOptions,
  });

  // 响应拦截
  autoRequest.interceptors.response.use(interceptorResponse, interceptorReject);

  return autoRequest;
}
